module.exports = __webpack_public_path__ + "static/bird-cabce440338fd4e3564792ab352df782.png";